import { render, staticRenderFns } from "./FormulationMappingIcon.vue?vue&type=template&id=901b9ca2&"
import script from "./FormulationMappingIcon.vue?vue&type=script&lang=js&"
export * from "./FormulationMappingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports